import styled from "styled-components";

export const DefaultTitle = styled.span`
  color: var(--palette-ss-000, #000);
  text-align: center;
  font-family: Poppins;
  font-size: 30px;
  font-style: normal;
  font-weight: 500;
`;

export default { DefaultTitle };
